import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { Observer } from "rxjs/Observer";

/**
 * @author Wesley Mascarenhas
 * @version $Id: alert.service.ts 76492 2018-01-16 19:48:32Z thiago.h.neri $
 */
@Injectable()
export class AlertService {
  alertMessage: Observable<{}>; //alertMessage: Observable<{string}>;
  _observer: Observer<any>;

  constructor() {
    this.startObservable();
  }

  public startObservable(){
    this.alertMessage = new Observable(observer => {
      this._observer = observer;
    }).share();
  }

  ngOnInit(): void {
    this.startObservable();
  }

  success(message: string) {
    setTimeout(() => {
      if (this._observer) {
        this._observer.next({ message: message, type: "success" });
      }
    }, 1000);
  }

  warn(message: string) {
    setTimeout(() => {
      if (this._observer) {
        this._observer.next({ message: message, type: "warning" });
      }
    }, 1000);
  }

  error(message: string, errorResponse: Response) {
    setTimeout(() => {
      if (this._observer) {
        if (errorResponse && errorResponse.status === 406) {
          message = errorResponse.json().result;
        }
        this._observer.next({ message: message, type: "danger" });
      }
    }, 1000);
  }

  ngOnDestroy() {
   
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/alert.service.ts